import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

import { ApiClass } from '@data/class/api-class'
import { IResponse, IResponseArray } from '@data/interfaces/iresponseArray.interface'
import { environment } from '@env/environment'

@Injectable({ providedIn: 'root' })
export class ApiActivitiesService extends ApiClass {
  constructor() {
    super()
    this.path = 'activities'
  }

  //* mis tareas del funnel — consumido por MainTableComponent
  getAll(page: number, limit: number, filters: any = {}): Observable<IResponseArray> {
    return this.http.post<IResponseArray>(`${environment.apiUrl}${this.path}/my?context=funnel`, { page, limit, filters })
  }

  getById(id: string): Observable<IResponse> {
    return this.getCollection(id)
  }

  getComments(id: string): Observable<IResponseArray> {
    return this.http.get<IResponseArray>(`${environment.apiUrl}${this.path}/${id}/comments`)
  }

  getHistory(id: string): Observable<IResponseArray> {
    return this.http.get<IResponseArray>(`${environment.apiUrl}${this.path}/${id}/history`)
  }

  //* el funnel no usa adminOverride; lo omite (firma única del motor compartido)
  changeState(id: string, payload: { newState: string; comment?: string; adminOverride?: boolean }): Observable<IResponse> {
    return this.patchCollection({ to: payload.newState, comment: payload.comment }, environment.apiUrl, `${this.path}/${id}/state`)
  }

  addComment(id: string, payload: { content: string; mentions?: string[] }): Observable<IResponse> {
    return this.http.post<IResponse>(`${environment.apiUrl}${this.path}/${id}/comments`, payload)
  }

  assign(id: string, payload: { assignedTo: string }): Observable<IResponse> {
    return this.patchCollection(payload, environment.apiUrl, `${this.path}/${id}/assign`)
  }
}
